import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from './IconUtils';

export const EmailIcon = ({ size = 'small', onClick, disabled = false, dataAttributes }: IconProps) => {
  return (
    <img
      src={Icons.EmailAt}
      alt="img"
      onClick={onClick}
      className={cn(styles.icon, getIconClasses(size, disabled))}
      {...dataAttributes}
    />
  );
};
